import { render, staticRenderFns } from "./InformacaoAcao.vue?vue&type=template&id=3c039de3&scoped=true"
import script from "./InformacaoAcao.vue?vue&type=script&lang=js"
export * from "./InformacaoAcao.vue?vue&type=script&lang=js"
import style0 from "./InformacaoAcao.vue?vue&type=style&index=0&id=3c039de3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c039de3",
  null
  
)

export default component.exports